
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unsupported-browser",
      function () {
        return require("private-next-pages/unsupported-browser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unsupported-browser"])
      });
    }
  